import { createSelector } from "reselect";

const selectAuthentication = (state) => state.authentication;

export const selectUserCredential = createSelector(
  [selectAuthentication],
  (authentication) => authentication.userCredential
);
export const selectLogInType = createSelector(
  [selectAuthentication],
  (authentication) => authentication.logInType
);

export const selectSignInStatus = createSelector(
  [selectAuthentication],
  (authentication) => authentication.isSignIn
);
export const selectIsOpenErrorMessageModal = createSelector(
  [selectAuthentication],
  (authentication) => authentication.isOpenErrorMessageModal
);

export const selectErrorMessage = createSelector(
  [selectAuthentication],
  (authentication) => authentication.errorMessage
);
export const selectIsOpenSignInModal = createSelector(
  [selectAuthentication],
  (authentication) => authentication.isOpenModal
);
export const selectIsLoading2FA = createSelector(
  [selectAuthentication],
  (authentication) => authentication.isLoading2FA
);
export const selectIsOpenVerify2FactorModal = createSelector(
  [selectAuthentication],
  (authentication) => authentication.isOpenVerify2FactorModal
);
export const select2FAToken = createSelector(
  [selectAuthentication],
  (authentication) => authentication.twoFactorToken
);
export const select2FAReferenceCode = createSelector(
  [selectAuthentication],
  (authentication) => authentication.referenceCode
);
export const select2FATwoFactorId = createSelector(
  [selectAuthentication],
  (authentication) => authentication.twoFactorId
);
export const select2FATwoFactorAuthenticationMethod = createSelector(
  [selectAuthentication],
  (authentication) => authentication.twoFactorAuthenticationMethod
);
// user acccount numbers
export const selectUserInformation = createSelector(
  [selectAuthentication],
  (authentication) => authentication.user
);
export const selectUserType = createSelector(
  [selectUserInformation],
  (userInformation) => userInformation?.userType
);
export const selectAccountMKT = createSelector(
  [selectAuthentication],
  (authentication) => authentication.mkt
);

export const selectAccountList = createSelector(
  [selectAuthentication],
  (authentication) => authentication.accountList
);
export const selectGetAccountListSuccess = createSelector(
  [selectAuthentication],
  (authentication) => authentication.getAccountListSuccess
);
export const selectIsMobileCompletedLogin = createSelector(
  [selectAuthentication],
  (authentication) => authentication.isMobileCompletedLogin
);
export const selectAccountInfo = createSelector(
  [selectAuthentication],
  (authentication) => authentication.accountInfo
);
export const selectAccountName = createSelector(
  [selectAuthentication],
  (authentication) => authentication.accountName
);
export const selectIsFetchingAuthentication = createSelector(
  [selectAuthentication],
  (authentication) => authentication.isFetching
);
